import React from "react";
import "../../style/main.scss";
const Footer = () => {
  return <div> </div>;
};

export default Footer;
